import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ai-texter" }
const _hoisted_3 = { class: "font-weight-bold" }
const _hoisted_4 = {
  key: 0,
  "data-cy": "aiTexterArticleName",
  class: "article-span"
}
const _hoisted_5 = { class: "ai-texter-style-selection" }
const _hoisted_6 = { class: "ai-texter" }
const _hoisted_7 = { class: "font-weight-bold" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "infoText" }
const _hoisted_10 = { class: "m-alert-icon" }
const _hoisted_11 = { class: "m-alert-content" }
const _hoisted_12 = { class: "mb-1 informationbase" }
const _hoisted_13 = { class: "infoText" }
const _hoisted_14 = { class: "m-alert-icon" }
const _hoisted_15 = { class: "m-alert-content" }
const _hoisted_16 = { class: "bg-white p-0 border-0" }
const _hoisted_17 = { class: "article-editor-card-body card-body position-relative" }
const _hoisted_18 = {
  key: 0,
  class: "h-100"
}
const _hoisted_19 = {
  key: 1,
  class: "h-100"
}
const _hoisted_20 = {
  key: 2,
  class: "h-100"
}
const _hoisted_21 = {
  key: 3,
  class: "h-100"
}
const _hoisted_22 = {
  key: 4,
  class: "h-100"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "ai-texter" }
const _hoisted_25 = { class: "font-weight-bold" }
const _hoisted_26 = {
  key: 0,
  class: "article-span"
}
const _hoisted_27 = { class: "ai-texter" }
const _hoisted_28 = { class: "ai-texter" }
const _hoisted_29 = { class: "font-weight-bold" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "field-container" }
const _hoisted_33 = {
  class: "ai-texter-table",
  "data-cy": "ai-texter-table"
}
const _hoisted_34 = { class: "ai-texter-table-header" }
const _hoisted_35 = { class: "ai-texter-table-col ai-texter-target-table-col" }
const _hoisted_36 = { class: "font-weight-bold" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 0,
  class: "ai-texter-table-row"
}
const _hoisted_39 = { class: "ai-texter-table-row-container" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["data-cy"]
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "ai-texter-table-row" }
const _hoisted_44 = { class: "ai-texter-table-row-container" }
const _hoisted_45 = {
  class: "ai-texter-table-col ai-texter-target-table-col",
  "data-cy": "select-target-master-data-description"
}
const _hoisted_46 = { class: "ai-texter-table-row" }
const _hoisted_47 = { class: "ai-texter-table-row-container" }
const _hoisted_48 = {
  class: "ai-texter-table-col ai-texter-target-table-col",
  "data-cy": "select-target-master-data-name"
}
const _hoisted_49 = { class: "font-weight-bold" }
const _hoisted_50 = { class: "current-value-box-generate-page" }
const _hoisted_51 = { key: 2 }
const _hoisted_52 = { class: "ai-texter" }
const _hoisted_53 = { class: "font-weight-bold" }
const _hoisted_54 = {
  key: 0,
  class: "article-span"
}
const _hoisted_55 = { class: "ai-texter" }
const _hoisted_56 = { class: "font-weight-bold" }
const _hoisted_57 = { class: "ai-texter-target-value" }
const _hoisted_58 = { class: "d-flex current-value-wrapper" }
const _hoisted_59 = { class: "drawer-content" }
const _hoisted_60 = { class: "current-value-box" }
const _hoisted_61 = { class: "drawer-collapse-button-icon" }
const _hoisted_62 = { class: "generated-value-area drawer-sibling" }
const _hoisted_63 = { class: "font-weight-bold" }
const _hoisted_64 = { class: "spinner-container" }
const _hoisted_65 = {
  key: 0,
  class: "footer w-100"
}
const _hoisted_66 = { class: "footer-actions" }
const _hoisted_67 = {
  key: 0,
  class: "row"
}
const _hoisted_68 = { class: "col d-flex justify-content-end" }
const _hoisted_69 = {
  key: 1,
  class: "row"
}
const _hoisted_70 = { class: "col" }
const _hoisted_71 = { class: "col d-flex justify-content-end" }
const _hoisted_72 = {
  key: 2,
  class: "row"
}
const _hoisted_73 = { class: "col" }
const _hoisted_74 = { class: "col d-flex justify-content-end" }

import { useArticleActions, useArticleState } from "@ContentEditor/store/composable/useArticle";
import Dropdown from "@common/components/Dropdown.vue";
import HTMLEditor from "@common/components/HTMLEditor.vue";
import Icon from "@common/components/Icon.vue";
import Spinner from "@common/components/Spinner.vue";
import warningModal from "@common/components/WarningModal.vue";
import { useContentLanguages } from "@common/composable/useMetaDataStore";
import { useSaveState, useUserSettings } from "@common/composable/useRootStore";
import { AiTexterTypes } from "@medapro-types/ContentEditor/Components/AiTexter";
import { ArticleMasterDataResultModel } from "@medapro-types/ContentEditor/content-editor-articles";
import { ApiErrorData, ValidationFeedbackEntry } from "@medapro-types/common/common";
import { RootActions } from "@medapro-types/common/rootstate";
import aiTexterApi from "@services/aiTexter";
import attributeGroupsApi from "@services/attributeGroups.js";
import catalogNodesApi from "@services/catalogNodes.js";
import ruleEvaluator from "@util/validations/ruleEvaluator";
import { AxiosError } from "axios";
import _ from "lodash";
import emitter from "tiny-emitter/instance";
import { Editor as TinymceEditor } from "tinymce";
import { computed, nextTick, onMounted, reactive, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useActions } from "vuex-composition-helpers";
import AttributeMultiSelectList from "./AITexter/AttributeMultiSelectList.vue";
import ErpMultiSelectList from "./AITexter/ErpMultiSelectList.vue";
import MasterDataMultiSelectList from "./AITexter/MasterDataMultiSelectList.vue";
import NotificationModal from "./AITexter/NotificationModal.vue";

type ViewModel = {
  isBusy: boolean;
  showContent: boolean;
  abortController: AbortController | null;
  apiErrorTitle: string | AxiosError;
  apiErrorMessage: string | ApiErrorData;
  currentValueOfItem: string | undefined;
  dataLanguage: string;
  dontShowMessageAgain: boolean;
  editableText: string;
  targetSectionsNames: AiTexterTypes.TargetSection[];
  erpSections: Record<string, AiTexterTypes.ErpSection[]> | null;
  globalAttributes: Record<string, AiTexterTypes.AttributeItem[]> | null;
  invariantAttributes: Record<string, AiTexterTypes.AttributeItem[]> | null;
  isDrawerOpen: boolean;
  isGenerating: boolean;
  isLoadingMasterData: boolean;
  legalInformationModal: boolean;
  masterData: Record<string, ArticleMasterDataResultModel> | null;
  selectedAttributeToTarget: AiTexterTypes.AttributeItem | AiTexterTypes.ErpSectionItem | string | null | undefined;
  selectedDropdownValue: string | null;
  selectedErpAttributes: AiTexterTypes.SelectedErpSectionItem[];
  selectedGlobalAttributes: AiTexterTypes.AttributeItem[];
  selectedInvariantAttributes: AiTexterTypes.AttributeItem[];
  selectedVariantAttributes: AiTexterTypes.AttributeItem[];
  selectedLanguage: string | null;
  selectedMasterData: AiTexterTypes.SelectedMasterData[];
  selectedMasterDataParameter: "name" | "description" | null;
  selectedTarget: (keyof ViewModel & ("globalAttributes" | "variantAttributes" | "invariantAttributes" | "masterData")) | string;
  selectedTextGeneratingStyleName: string;
  selectedTextGeneratingStyleOriginalText: string;
  selectedTextGeneratingStyleText: string;
  selectedTextGeneratingTargetName: string;
  serializedErpData: unknown;
  selectedPage: string;
  showWarning: boolean;
  tableRows: AiTexterTypes.AttributeItem[] | AiTexterTypes.ErpSectionItem[] | AiTexterTypes.MasterDataItem[];
  targetSelectionList: string[];
  textGeneratingStyles: AiTexterTypes.TextGeneratingStyle[];
  translationLanguage: string | null;
  variantAttributes: Record<string, AiTexterTypes.AttributeItem[]> | null;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'AiTexterModal',
  props: {
    value: { type: Boolean },
    language: {},
    dataCy: {}
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const { t: $t } = useI18n();


const aiTexterModal = ref();
const editor = ref<TinymceEditor | null>(null);

//#region StoreData
const { userSettings } = useUserSettings();
const { saveUserSettings } = useActions<RootActions>(["saveUserSettings"]);

const { addSavingPromise, getSavePromiseResultAndResolve } = useSaveState();

const { aiTexterStyles, masterdata, globalAttributes, variantAttributes, invariantAttributes, erpSections, metadata } = useArticleState();
const { saveErpSections, saveMasterData, saveGlobalAttributes, saveInvariantAttributes, saveVariantAttributes } = useArticleActions();
const { loadMasterDataIfNecessary, loadGlobalAttributes, loadVariantAttributes, loadInvariantAttributes, loadErpAttributes } = useArticleActions();
const { languageCodes, primaryLanguageCode, contentLanguages } = useContentLanguages();
const targetSelectionList = ["masterData", "invariantAttributes", "variantAttributes", "globalAttributes"];

const meta = ref({
  activeTab: "master.data",
  tabs: [
    { name: "master.data", show: true },
    { name: "global.attributes", show: true },
    { name: "text.attributes", show: true },
    { name: "table.attributes", show: true },
    { name: "erp.attributes", show: true }
  ]
});

const actionExecuted = ref(false);

const vm = reactive<ViewModel>({
  isBusy: false,
  showContent: false,
  abortController: null,
  apiErrorTitle: "",
  apiErrorMessage: "",
  currentValueOfItem: "",
  dataLanguage: primaryLanguageCode.value,
  dontShowMessageAgain: userSettings.value.AITexterLegalInformationAccepted === "true",
  editableText: "",
  targetSectionsNames: [],
  erpSections: null,
  globalAttributes: null,
  invariantAttributes: null,
  isDrawerOpen: true,
  isGenerating: false,
  isLoadingMasterData: false,
  legalInformationModal: false,
  masterData: null,
  selectedAttributeToTarget: null,
  selectedDropdownValue: null,
  selectedErpAttributes: [],
  selectedGlobalAttributes: [],
  selectedInvariantAttributes: [],
  selectedVariantAttributes: [],
  selectedLanguage: null,
  selectedMasterData: [],
  selectedMasterDataParameter: null,
  selectedTarget: "masterData",
  selectedTextGeneratingStyleName: "",
  selectedTextGeneratingStyleOriginalText: "",
  selectedTextGeneratingStyleText: "",
  selectedTextGeneratingTargetName: "masterData",
  serializedErpData: {},
  selectedPage: "start",
  showWarning: false,
  tableRows: [],
  targetSelectionList: targetSelectionList,
  textGeneratingStyles: [],
  translationLanguage: languageCodes.value[1] ?? null,
  variantAttributes: null
});

const onModalClosed = () => {
  actionExecuted.value = false;
};

const localModel = computed({
  get() {
    return props.value;
  },
  set(nv) {
    emits("input", nv);
  }
});

const globalAttributesForSelectedLanguage = computed(() => {
  if (vm.selectedLanguage) {
    return vm.globalAttributes?.[vm.selectedLanguage] ?? [];
  } else {
    return [];
  }
});
const textAttributesForSelectedLanguage = computed(() => {
  if (vm.selectedLanguage) {
    return vm.invariantAttributes?.[vm.selectedLanguage];
  } else {
    return [];
  }
});
const tableAttributesSelectedLanguage = computed(() => {
  if (vm.selectedLanguage) {
    return vm.variantAttributes?.[vm.selectedLanguage];
  } else {
    return [];
  }
});

const fallbackLanguageCode = computed(() => {
  for (const lang of contentLanguages.value.enabled) {
    if (lang.languageCode === vm.selectedLanguage) {
      return lang.fallbackLanguageCode;
    }
  }

  return undefined;
});

watch(
  () => userSettings,
  () => {
    vm.dataLanguage = contentLanguages.value.enabled[0].languageCode;
    vm.translationLanguage = contentLanguages.value.enabled[1]?.languageCode ?? null;
  },
  { deep: true }
);

const loadAndSetData = async () => {
  await getSavePromiseResultAndResolve();

  const _loadPromises: Promise<unknown>[] = [];
  const articleId = metadata.value.articleId;
  for (const lang of languageCodes.value) {
    _loadPromises.push(loadMasterDataIfNecessary({ articleId: articleId, language: lang }));
    _loadPromises.push(loadGlobalAttributes({ articleId: articleId, language: lang }));
    _loadPromises.push(loadVariantAttributes({ articleId: articleId, language: lang }));
    _loadPromises.push(loadInvariantAttributes({ articleId: articleId, language: lang }));
    _loadPromises.push(loadErpAttributes({ articleId: articleId, language: lang }));
  }

  await Promise.all(_loadPromises);

  vm.masterData = _.cloneDeep(masterdata.value);
  vm.globalAttributes = _.cloneDeep(globalAttributes.value);
  vm.variantAttributes = _.cloneDeep(variantAttributes.value);
  vm.invariantAttributes = _.cloneDeep(invariantAttributes.value);
  vm.erpSections = _.cloneDeep(erpSections.value);

  if (props.language == "dataLanguage") {
    vm.selectedLanguage = vm.dataLanguage;
  }
  if (props.language == "translationLanguage") {
    vm.selectedLanguage = vm.translationLanguage;
  }

  vm.selectedPage = "start";
  vm.selectedTarget = "masterData";
  meta.value.activeTab = "master.data";
  vm.targetSectionsNames = [
    { id: 1, name: "masterData", translatedName: $t("AiTexter.masterData") },
    { id: 2, name: "invariantAttributes", translatedName: $t("AiTexter.invariantAttributes") },
    { id: 3, name: "variantAttributes", translatedName: $t("AiTexter.variantAttributes") },
    { id: 4, name: "globalAttributes", translatedName: $t("AiTexter.globalAttributes") }
  ];

  await constructMasterData();
  constructErpSections();
  // Now that the fallback names are considered, we check if have erp sections to include
  if (vm.selectedLanguage && vm.erpSections?.[vm.selectedLanguage]) {
    vm.erpSections?.[vm.selectedLanguage].forEach((section, index) => {
      const exists = vm.targetSectionsNames.some((item) => item.name == section.name);
      if (!exists) {
        if (section.erpAttributes?.length && section.name !== "") {
          vm.targetSectionsNames.push({ id: 5 + index, name: section.name, translatedName: section.name });
        }
      }
    });
  }

  constructAttributes();
  if (vm.selectedLanguage && vm.masterData?.[vm.selectedLanguage]) {
    setCurrentMasterDataPath(vm.masterData[vm.selectedLanguage].name, "name");
  }
  getTextStylesFromApi();
  vm.selectedTextGeneratingTargetName = "masterData";
};

const isLoadedAll = computed(() => {
  return !!vm.masterData && !!vm.globalAttributes && !!vm.variantAttributes && !!vm.invariantAttributes && !!vm.erpSections;
});

watch(
  () => isLoadedAll.value,
  (nv) => {
    nextTick(() => {
      vm.showContent = nv;
    });
  }
);

const arrayToString = (array: unknown) => {
  if (!Array.isArray(array)) {
    return "";
  }
  return array.filter((item) => item !== "" && item !== null).join("/");
};
const constructMasterData = async () => {
  vm.isLoadingMasterData = true;
  try {
    if (vm.selectedLanguage) {
      const masterDataOfSelectedLanguage = vm.masterData?.[vm.selectedLanguage];
      if (!masterDataOfSelectedLanguage) {
        return;
      }

      const fetchedCatalogNodePathInBaseCatalog: AiTexterTypes.CatalogPathItem[] = await catalogNodesApi.getCatalogNodePathInBaseCatalog(
        masterDataOfSelectedLanguage.variationGroupId,
        vm.selectedLanguage
      );
      const fetchedAttributeGroupsApiPath: AiTexterTypes.AttributeGroupPathItem[] = await attributeGroupsApi.getPath(
        vm.selectedLanguage,
        masterDataOfSelectedLanguage.attributeGroupId
      );

      const catalogGroupPath = fetchedCatalogNodePathInBaseCatalog.map((obj) => {
        return obj.name;
      });

      const attributeGroupPath = fetchedAttributeGroupsApiPath.filter((obj) => obj.name !== "").map((obj) => obj.name);
      Object.assign(masterDataOfSelectedLanguage, {
        catalogGroupPath: arrayToString(catalogGroupPath),
        attributeGroupPath: arrayToString(attributeGroupPath)
      });

      if (
        (masterDataOfSelectedLanguage.name === "" ||
          masterDataOfSelectedLanguage.description === "" ||
          masterDataOfSelectedLanguage.variationGroupName === "") &&
        fallbackLanguageCode.value
      ) {
        const masterDataKeys: ["description", "name", "variationGroupName"] = ["description", "name", "variationGroupName"];
        masterDataKeys.forEach((attrType) => {
          if (vm.masterData && !masterDataOfSelectedLanguage[attrType]) {
            masterDataOfSelectedLanguage[attrType] = fallbackLanguageCode.value ? vm.masterData[fallbackLanguageCode.value][attrType] : "";
          }
        });
      }
    }
  } catch (error) {
    console.error("An Error has occured during loading master data.", error);
  } finally {
    vm.isLoadingMasterData = false;
  }
};
const constructAttributes = () => {
  if (fallbackLanguageCode.value) {
    const possibleAttributes: Array<"globalAttributes" | "variantAttributes" | "invariantAttributes"> = [
      "globalAttributes",
      "variantAttributes",
      "invariantAttributes"
    ];

    const possibleAttributeKeys: Array<keyof AiTexterTypes.AttributeItem & ("name" | "value" | "unit")> = ["name", "value", "unit"];

    possibleAttributes.forEach((attrType) => {
      if (vm[attrType] && vm.selectedLanguage) {
        vm[attrType]?.[vm.selectedLanguage].forEach((x, index) => {
          possibleAttributeKeys.forEach((key) => {
            if (x[key] === "" && fallbackLanguageCode.value) {
              x[key] = vm[attrType]?.[fallbackLanguageCode.value][index][key] ?? "";
            }
          });
        });
      }
    });
  }
};

const constructErpSections = () => {
  if (vm.selectedLanguage) {
    const serializedErpData = vm.erpSections?.[vm.selectedLanguage]
      .map((erpSection, sectionIndex) => {
        const fallbackSection = fallbackLanguageCode.value ? vm.erpSections?.[fallbackLanguageCode.value]?.[sectionIndex] : undefined;
        return erpSection.erpAttributes?.map((erpAttributes, attrIndex) => {
          const fallbackAttributes = fallbackSection?.erpAttributes?.[attrIndex];
          return {
            erpSectionId: erpSection.erpSectionId,
            erpSectionName: erpSection.name || fallbackSection?.name || "",
            erpAttributeName: erpAttributes.name || fallbackAttributes?.name || "",
            erpAttributeValue: erpAttributes.value || fallbackAttributes?.value || "",
            erpAttributeUnit: erpAttributes.unit || fallbackAttributes?.unit || "",
            erpAttributeType: erpAttributes.userType || fallbackAttributes?.userType || ""
          };
        });
      })
      .flat();

    //Set fallback language erp attribute names to selected language erp attribute names if empty
    vm.erpSections?.[vm.selectedLanguage].map((erpSection, sectionIndex) => {
      const fallbackSection = fallbackLanguageCode.value ? vm.erpSections?.[fallbackLanguageCode.value]?.[sectionIndex] : undefined;
      erpSection.name = erpSection.name || fallbackSection?.name || "";
      return erpSection.erpAttributes?.map((erpAttributes, attrIndex) => {
        const fallbackAttributes = fallbackSection?.erpAttributes?.[attrIndex];
        erpAttributes.name = erpAttributes.name || fallbackAttributes?.name || "";
      });
    });
    vm.serializedErpData = serializedErpData;
  }
};

const selectTab = (tab: string) => {
  meta.value.activeTab = tab;
};

const setCurrentAttributePath = (currentValue: AiTexterTypes.AttributeItem | AiTexterTypes.ErpSectionItem | undefined) => {
  if (!currentValue) return;
  vm.selectedAttributeToTarget = currentValue;
  vm.currentValueOfItem = currentValue.value;
};

const setCurrentMasterDataPath = (currentValue: string | undefined, masterDataParameter: "name" | "description") => {
  vm.selectedMasterDataParameter = masterDataParameter;
  vm.selectedAttributeToTarget = currentValue;
  vm.currentValueOfItem = currentValue;
};

const sendResult = async () => {
  if (vm.selectedTarget === "masterData") {
    await handleMasterDataUpdate();
    emits("input", false);
    return;
  }

  if (["invariantAttributes", "globalAttributes", "variantAttributes"].includes(vm.selectedTarget)) {
    await handleAttributeUpdate();
    emits("input", false);
    return;
  }
  if (vm.selectedAttributeToTarget && !_.isString(vm.selectedAttributeToTarget)) {
    vm.selectedAttributeToTarget.value = vm.editableText;
    contentLanguages.value.enabled.forEach((lang) =>
      addSavingPromise(
        saveErpSections({
          language: lang.languageCode,
          model: vm.erpSections?.[lang.languageCode]
        })
      )
    );
    await getSavePromiseResultAndResolve();
    emits("input", false);
  }
};

const handleMasterDataUpdate = async () => {
  if (vm.selectedLanguage) {
    if (!vm.selectedMasterDataParameter || !["name", "description"].includes(vm.selectedMasterDataParameter) || _.isEmpty(vm.masterData)) return;

    vm.masterData[vm.selectedLanguage][vm.selectedMasterDataParameter] = vm.editableText;

    const args = {
      inheritanceOptions: {
        status: false,
        assignedUser: false,
        validity: false
      },
      model: vm.masterData[vm.selectedLanguage]
    };
    addSavingPromise(
      saveMasterData({
        language: vm.selectedLanguage,
        articleData: args
      })
    );

    await getSavePromiseResultAndResolve();
    emitter.emit("reload-after-ai-update");
  }
};

const isAttributeItem = (e: unknown): e is AiTexterTypes.AttributeItem => {
  return !!e && Object.hasOwn(e, "value") && Object.hasOwn(e, "name") && Object.hasOwn(e, "isTranslatable") && Object.hasOwn(e, "attributeId");
};

const isErpSectionItem = (e: unknown): e is AiTexterTypes.ErpSectionItem => {
  return !!e && Object.hasOwn(e, "value") && Object.hasOwn(e, "name") && Object.hasOwn(e, "attributeId");
};

const isSelectedErpSectionItem = (e: unknown): e is AiTexterTypes.SelectedErpSectionItem => {
  return (
    !!e &&
    Object.hasOwn(e, "erpSectionName") &&
    Object.hasOwn(e, "erpAttributeName") &&
    Object.hasOwn(e, "erpAttributeValue") &&
    Object.hasOwn(e, "erpAttributeUnit")
  );
};

const isSelectedAttributeItem = (e: unknown): e is AiTexterTypes.SelectedAttributeItem => {
  return !!e && Object.hasOwn(e, "name") && Object.hasOwn(e, "value") && Object.hasOwn(e, "unit");
};

const handleAttributeUpdate = async () => {
  if (vm.selectedAttributeToTarget && !_.isString(vm.selectedAttributeToTarget) && isAttributeItem(vm.selectedAttributeToTarget) && vm.selectedLanguage) {
    vm.selectedAttributeToTarget.value = vm.editableText;
    const getModel = () => {
      switch (vm.selectedTarget) {
        case "globalAttributes":
          return contentLanguages.value.enabled.map((x) => ({
            language: x.languageCode,
            data: vm.globalAttributes?.[x.languageCode]
          }));
        case "invariantAttributes":
          return contentLanguages.value.enabled.map((x) => ({
            language: x.languageCode,
            data: vm.invariantAttributes?.[x.languageCode]
          }));
        case "variantAttributes":
          return contentLanguages.value.enabled.map((x) => ({
            language: x.languageCode,
            data: vm.variantAttributes?.[x.languageCode]
          }));

        default:
          break;
      }
    };

    const model = getModel();

    switch (vm.selectedTarget) {
      case "globalAttributes":
        model?.forEach((x) => {
          addSavingPromise(
            saveGlobalAttributes({
              language: x.language,
              model: x.data
            })
          );
        });
        break;
      case "invariantAttributes":
        model?.forEach((x) => {
          addSavingPromise(
            saveInvariantAttributes({
              language: x.language,
              model: x.data
            })
          );
        });
        break;
      case "variantAttributes":
        model?.forEach((x) => {
          addSavingPromise(
            saveVariantAttributes({
              language: x.language,
              model: x.data
            })
          );
        });

        break;
    }

    await getSavePromiseResultAndResolve();
    emitter.emit("reload-after-ai-update");
  }
};

const openGenerateAiTextPage = () => {
  if (vm.selectedPage == "generate" && !vm.dontShowMessageAgain) {
    vm.legalInformationModal = true;
  }

  if (vm.dontShowMessageAgain) {
    vm.selectedPage = "generateAiText";
    dataforPrompting();
  }
};

const dataforPrompting = async () => {
  const promptData: AiTexterTypes.PromptData[] = [];
  const attributeMappings = {
    selectedMasterData: "MasterData",
    selectedGlobalAttributes: "GlobalAttribute",
    selectedVariantAttributes: "TableAttribute",
    selectedInvariantAttributes: "TextAttribute",
    selectedErpAttributes: "ErpAttribute"
  };

  Object.entries(attributeMappings).forEach(([key, type]) => {
    const attributeData =
      vm[
        key as keyof ViewModel &
          ("selectedMasterData" | "selectedGlobalAttributes" | "selectedVariantAttributes" | "selectedInvariantAttributes" | "selectedErpAttributes")
      ];

    if (!_.isEmpty(attributeData)) {
      const sourceValues: AiTexterTypes.PromptDataSourceValue[] = attributeData.map((item) => {
        if (isSelectedErpSectionItem(item)) {
          return {
            section: item.erpSectionName || "",
            name: item.erpAttributeName || "",
            value: item.erpAttributeValue || "",
            unit: item.erpAttributeUnit || ""
          };
        } else if (isSelectedAttributeItem(item)) {
          return {
            name: _.isString(item.name) ? item.name : "",
            value: _.isString(item.value) ? item.value : "",
            unit: _.isString(item.unit) ? item.unit : ""
          };
        } else {
          return {
            name: _.isString(item.name) ? item.name : "",
            value: _.isString(item.value) ? item.value : "",
            unit: ""
          };
        }
      });

      promptData.push({ type, sourceValues });
    }
  });

  vm.editableText = "";
  vm.isGenerating = true;
  try {
    vm.abortController = new AbortController();
    if (vm.selectedLanguage) {
      const generatedTextFromApi = await aiTexterApi.generateText(
        vm.selectedLanguage,
        promptData,
        vm.selectedTextGeneratingStyleOriginalText,
        vm.abortController.signal
      );
      vm.editableText = generatedTextFromApi;
    }
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      const errorData: ApiErrorData | undefined = error.response?.data;
      switch (errorData?.error) {
        case "InvalidApiKey":
          vm.apiErrorTitle = $t(`api.errorTitles.InvalidApiKey`);
          vm.apiErrorMessage = $t(`api.errors.InvalidApiKey`);
          break;
        case "InternalServerError":
          vm.apiErrorTitle = $t(`api.errorTitles.InternalServerError`);
          vm.apiErrorMessage = $t(`api.errors.InternalServerError`);
          break;
        case "RateLimitExceeded":
          vm.apiErrorTitle = $t(`api.errorTitles.RateLimitExceeded`);
          vm.apiErrorMessage = $t(`api.errors.RateLimitExceeded`);
          break;
        case "ServiceUnavailable":
          vm.apiErrorTitle = $t(`api.errorTitles.ServiceUnavailable`);
          vm.apiErrorMessage = $t(`api.errors.ServiceUnavailable`);
          break;
        case "InsufficientQuota":
          vm.apiErrorTitle = $t(`api.errorTitles.InsufficientQuota`);
          vm.apiErrorMessage = $t(`api.errors.InsufficientQuota`);
          break;
        case "CanceledError":
          vm.apiErrorTitle = $t(`api.errorTitles.CanceledError`);
          vm.apiErrorMessage = $t(`api.errors.CanceledError`);
          break;
        default:
          vm.apiErrorTitle = $t(`api.errorTitles.FailedToGenerateText`);
          vm.apiErrorMessage = $t(`api.errors.FailedToGenerateText`);
          break;
      }
    }
    vm.showWarning = true;
  } finally {
    vm.isGenerating = false;
  }
};

const cancelRequest = () => {
  if (vm.abortController) {
    vm.abortController.abort();
  }
  aiTexterModal.value?.hide();
};

const updateTextGeneratingStyle = (selectedStyle: string) => {
  const style = vm.textGeneratingStyles?.find((styles) => styles.name === selectedStyle);
  if (style) {
    vm.selectedTextGeneratingStyleName = style.name;
    vm.selectedTextGeneratingStyleText = style.text;
    vm.selectedTextGeneratingStyleOriginalText = style.originalText;
  }
};

const updateTextGeneratingTarget = (selectedTarget: AiTexterTypes.SelectedTarget, triggeredFromNextButton: boolean) => {
  vm.selectedTarget = selectedTarget;
  const target = vm.targetSectionsNames.find((section) => section.name === selectedTarget);

  if (target) {
    vm.selectedTextGeneratingTargetName = target.name;
  }
  if (vm.selectedLanguage) {
    const attributeMapping: AiTexterTypes.AttributeMapping = {
      globalAttributes: vm.globalAttributes?.[vm.selectedLanguage],
      invariantAttributes: vm.invariantAttributes?.[vm.selectedLanguage],
      variantAttributes: vm.variantAttributes?.[vm.selectedLanguage]
    };
    if (selectedTarget in attributeMapping) {
      vm.tableRows = attributeMapping[selectedTarget as keyof AiTexterTypes.AttributeMapping]?.filter((attr) => attr.defaultValueOnly === false) ?? [];
    }
    const tempErpSectionItems: AiTexterTypes.ErpSectionItem[] = [];
    vm.erpSections?.[vm.selectedLanguage].forEach((section) => {
      if (selectedTarget == section.name) {
        section.erpAttributes?.forEach((attributes) => {
          if (attributes.defaultValueOnly === false) tempErpSectionItems.push(attributes);
        });
        vm.tableRows = tempErpSectionItems;
      }
    });

    if (actionExecuted.value && triggeredFromNextButton !== undefined) return;
    const masterDataName = vm.masterData?.[vm.selectedLanguage]?.description;
    if (selectedTarget == "masterData") {
      setCurrentMasterDataPath(masterDataName, "description");
    } else {
      isErpSectionItem(vm.tableRows[0]) || isAttributeItem(vm.tableRows[0]) ? setCurrentAttributePath(vm.tableRows[0]) : "";
    }
  }
  actionExecuted.value = true;
};

function switchPageNext() {
  if (vm.selectedPage == "start") {
    vm.selectedPage = "generate";

    updateTextGeneratingTarget(vm.selectedTarget, true);

    return;
  }
}
function switchPageBack() {
  if (vm.selectedPage == "generate") {
    vm.selectedPage = "start";
    return;
  }
  if (vm.selectedPage == "generateAiText") {
    if (vm.abortController) {
      vm.abortController.abort();
    }
    vm.selectedPage = "generate";
    return;
  }
}

const validationFeedbacks = computed(() => {
  const rules = {
    name: [
      {
        rule: () => _.isEmpty(vm.textGeneratingStyles),
        msg: $t("validation.noStylesAvailable"),
        severity: "error"
      },
      {
        rule: () => typeof vm.selectedTextGeneratingStyleName === "string" && vm.selectedTextGeneratingStyleName.trim() == "",
        msg: $t("validation.stylesAreEmpty"),
        severity: "warning"
      }
    ]
  };

  const feedbacks = <Record<string, ValidationFeedbackEntry>>ruleEvaluator(vm.textGeneratingStyles, rules);
  return feedbacks;
});
async function getTextStylesFromApi() {
  const staticPromptStyles = [
    "MarketingText_short",
    "MarketingText_long",
    "PressNote",
    "ArticleDescriptionMax80Characters",
    "FactualPrompt",
    "FormalPrompt",
    "InformalPrompt",
    "CatchyPrompt",
    "BlogPrompt",
    "SocialMediaWithTagsPrompt",
    "SocialMediaWithoutTagsPrompt",
    "TwitterPrompt",
    "HtmlPrompt",
    "BulletPrompt"
  ];
  try {
    if (vm.selectedLanguage) {
      vm.textGeneratingStyles = aiTexterStyles.value[vm.selectedLanguage].map((style) => {
        if (staticPromptStyles.includes(style)) {
          return {
            name: $t(`AiTexter.PromptStyleName.${style}`),
            text: $t(`AiTexter.PromptStyleText.${style}`),
            originalText: style
          };
        } else {
          return {
            name: style,
            text: "",
            originalText: style
          };
        }
      });

      vm.selectedTextGeneratingStyleName = vm.textGeneratingStyles[0].name;
      vm.selectedTextGeneratingStyleText = vm.textGeneratingStyles[0].text;
      vm.selectedTextGeneratingStyleOriginalText = vm.textGeneratingStyles[0].originalText;
    }
  } catch (err) {
    console.log("err", err);
  }
}

const setNotificationStatus = async (dontShowMessageAgain: boolean) => {
  if (vm.selectedPage == "generate" && !vm.dontShowMessageAgain) {
    vm.legalInformationModal = false;
  }
  vm.dontShowMessageAgain = dontShowMessageAgain;
  await saveUserSettings({ AITexterLegalInformationAccepted: vm.dontShowMessageAgain ? "true" : "false" });
  vm.selectedPage = "generateAiText";
  dataforPrompting();
};

onMounted(() => {
  editor.value?.execCommand("RemoveFormat");
  editor.value?.execCommand("mceRepaint");
});

return (_ctx: any,_cache: any) => {
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_alert = _resolveComponent("b-alert")!
  const _component_b_nav_item = _resolveComponent("b-nav-item")!
  const _component_b_nav = _resolveComponent("b-nav")!
  const _component_b_overlay = _resolveComponent("b-overlay")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_btn = _resolveComponent("b-btn")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_b_modal, {
      "data-cy": _ctx.dataCy,
      title: _unref($t)('AiTexter.AiTexter'),
      "modal-class": "ai-texter-modal",
      "header-close-content": "",
      size: "xl",
      modelValue: localModel.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((localModel).value = $event)),
      centered: "",
      ref_key: "aiTexterModal",
      ref: aiTexterModal,
      onShow: loadAndSetData,
      onHide: cancelRequest,
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      onHidden: onModalClosed
    }, {
      "modal-footer": _withCtx(({ cancel }) => [
        (vm.showContent && isLoadedAll.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
              _createElementVNode("div", _hoisted_66, [
                (vm.selectedPage == 'start')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createVNode(_component_b_btn, {
                          onClick: switchPageNext,
                          "data-cy": "ai-texter-next-btn",
                          variant: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref($t)("AiTexter.Next")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_b_btn, {
                          class: "mr-0",
                          onClick: cancel,
                          "data-cy": "cancel-ai-texter"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref($t)("AiTexter.Cancel")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (vm.selectedPage == 'generate')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, [
                        _createVNode(_component_b_btn, {
                          class: "ml-0",
                          onClick: switchPageBack
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Icon, {
                              icon: "ChevronLeft",
                              class: "mr-1 backBtn"
                            }),
                            _createTextVNode(_toDisplayString(_unref($t)("AiTexter.Back")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _createVNode(_component_b_btn, {
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (openGenerateAiTextPage())),
                          "data-cy": "ai-texter-generate-btn",
                          variant: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref($t)("AiTexter.Generate")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_b_btn, {
                          class: "mr-0",
                          onClick: cancel
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref($t)("AiTexter.Cancel")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (vm.selectedPage == 'generateAiText')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                      _createElementVNode("div", _hoisted_73, [
                        _createVNode(_component_b_btn, {
                          class: "ml-0",
                          onClick: switchPageBack
                        }, {
                          default: _withCtx(() => [
                            _createVNode(Icon, {
                              icon: "ChevronLeft",
                              class: "mr-1 backBtn"
                            }),
                            _createTextVNode(_toDisplayString(_unref($t)("AiTexter.Back")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _createVNode(_component_b_btn, {
                          disabled: vm.isGenerating,
                          variant: "primary",
                          "data-cy": "ai-texter-apply-text",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (sendResult()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref($t)("AiTexter.Apply")), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_component_b_btn, {
                          class: "mr-0",
                          onClick: cancel
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref($t)("AiTexter.Cancel")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        (vm.showContent && isLoadedAll.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (vm.selectedPage == 'start')
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("label", _hoisted_3, _toDisplayString(_unref($t)("AiTexter.Article")), 1),
                      (vm.selectedLanguage && vm.masterData?.[vm.selectedLanguage])
                        ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [
                            _createTextVNode(_toDisplayString(vm.masterData?.[vm.selectedLanguage].name), 1)
                          ])), [
                            [_directive_tooltip, vm.masterData?.[vm.selectedLanguage].name]
                          ])
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_b_form_group, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("label", _hoisted_7, _toDisplayString(_unref($t)("AiTexter.Style")), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _withDirectives((_openBlock(), _createBlock(Dropdown, {
                                modelValue: vm.selectedTextGeneratingStyleName,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.selectedTextGeneratingStyleName) = $event)),
                                class: _normalizeClass([{ 'border-danger': validationFeedbacks.value.name.type == 'error', 'border-warning': validationFeedbacks.value.name.type == 'warning' }, "width-minus-button"]),
                                items: vm.textGeneratingStyles,
                                "value-field": "name",
                                "text-field": "name",
                                "data-cy": vm.textGeneratingStyles && vm.textGeneratingStyles.length > 0 ? 'ai-Texter-textstyles-dropdown' : 'emptyTextStyles',
                                onInput: updateTextGeneratingStyle
                              }, {
                                "item-template": _withCtx(({ entry }) => [
                                  entry
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(entry.name), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["modelValue", "class", "items", "data-cy"])), [
                                [_directive_tooltip, validationFeedbacks.value.name.type]
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_b_alert, {
                            class: "m-alert",
                            show: "",
                            variant: "light"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(Icon, {
                                  icon: validationFeedbacks.value.name.type == 'error' ? 'WatcherWarning' : 'Info',
                                  size: "11px"
                                }, null, 8, ["icon"])
                              ]),
                              _createElementVNode("div", _hoisted_11, _toDisplayString(validationFeedbacks.value.name.type == "error" ? validationFeedbacks.value.name.feedback : vm.selectedTextGeneratingStyleText), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("h5", _hoisted_12, _toDisplayString(_unref($t)("AiTexter.informationbase")), 1),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_b_alert, {
                          class: "m-alert",
                          show: "",
                          variant: "light"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(Icon, {
                                icon: "Info",
                                size: "11px"
                              })
                            ]),
                            _createElementVNode("div", _hoisted_15, _toDisplayString(_unref($t)("AiTexter.informationbaseNotification")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("header", _hoisted_16, [
                        _createVNode(_component_b_nav, { tabs: "" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meta.value.tabs, (tab) => {
                              return (_openBlock(), _createBlock(_component_b_nav_item, {
                                active: meta.value.activeTab == tab.name,
                                key: tab.name,
                                onClick: ($event: any) => (selectTab(tab.name)),
                                "data-cy": 'ai-texter-' + tab.name + '-tab'
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref($t)(tab.name, 2)), 1)
                                ]),
                                _: 2
                              }, 1032, ["active", "onClick", "data-cy"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        (vm.selectedLanguage && meta.value.activeTab == 'master.data' && vm.masterData?.[vm.selectedLanguage])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createVNode(_component_b_overlay, {
                                "z-index": "20",
                                opacity: "0.9",
                                variant: "white",
                                "no-wrap": "",
                                "data-cy": "spinnerRight",
                                show: vm.isLoadingMasterData
                              }, {
                                overlay: _withCtx(() => [
                                  _createVNode(Spinner, { size: "48" })
                                ]),
                                _: 1
                              }, 8, ["show"]),
                              (!vm.isLoadingMasterData)
                                ? (_openBlock(), _createBlock(MasterDataMultiSelectList, {
                                    key: 0,
                                    items: vm.masterData?.[vm.selectedLanguage]
                                  }, null, 8, ["items"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (meta.value.activeTab == 'global.attributes')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createVNode(AttributeMultiSelectList, {
                                items: globalAttributesForSelectedLanguage.value,
                                selectedItems: vm.selectedGlobalAttributes,
                                "onUpdate:selectedItems": _cache[1] || (_cache[1] = ($event: any) => ((vm.selectedGlobalAttributes) = $event))
                              }, null, 8, ["items", "selectedItems"])
                            ]))
                          : _createCommentVNode("", true),
                        (meta.value.activeTab == 'text.attributes')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createVNode(AttributeMultiSelectList, {
                                items: textAttributesForSelectedLanguage.value,
                                selectedItems: vm.selectedInvariantAttributes,
                                "onUpdate:selectedItems": _cache[2] || (_cache[2] = ($event: any) => ((vm.selectedInvariantAttributes) = $event)),
                                isText: true,
                                isAiTexterOpen: props.value
                              }, null, 8, ["items", "selectedItems", "isAiTexterOpen"])
                            ]))
                          : _createCommentVNode("", true),
                        (meta.value.activeTab == 'table.attributes')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createVNode(AttributeMultiSelectList, {
                                items: tableAttributesSelectedLanguage.value,
                                selectedItems: vm.selectedVariantAttributes,
                                "onUpdate:selectedItems": _cache[3] || (_cache[3] = ($event: any) => ((vm.selectedVariantAttributes) = $event))
                              }, null, 8, ["items", "selectedItems"])
                            ]))
                          : _createCommentVNode("", true),
                        (meta.value.activeTab == 'erp.attributes')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createVNode(ErpMultiSelectList, {
                                items: vm.serializedErpData,
                                selectedItems: vm.selectedErpAttributes,
                                "onUpdate:selectedItems": _cache[4] || (_cache[4] = ($event: any) => ((vm.selectedErpAttributes) = $event))
                              }, null, 8, ["items", "selectedItems"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (vm.selectedPage == 'generate')
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, _toDisplayString(_unref($t)("AiTexter.Article")), 1),
                      (vm.selectedLanguage && vm.masterData?.[vm.selectedLanguage])
                        ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_26, [
                            _createTextVNode(_toDisplayString(vm.masterData?.[vm.selectedLanguage].name), 1)
                          ])), [
                            [_directive_tooltip, vm.masterData?.[vm.selectedLanguage].name]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(_component_b_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_col, { cols: "6" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_form_group, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("label", _hoisted_29, _toDisplayString(_unref($t)("AiTexter.Target")), 1)
                                  ]),
                                  _createElementVNode("div", null, [
                                    _withDirectives((_openBlock(), _createBlock(Dropdown, {
                                      modelValue: vm.selectedTextGeneratingTargetName,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((vm.selectedTextGeneratingTargetName) = $event)),
                                      "value-field": "name",
                                      "text-field": "translatedName",
                                      items: vm.targetSectionsNames,
                                      class: "width-minus-button",
                                      "data-cy": "ai-Texter-target-selection-dropdown",
                                      onInput: updateTextGeneratingTarget
                                    }, {
                                      "item-template": _withCtx(({ entry }) => [
                                        (entry.name && typeof entry.name === 'string' && vm.selectedLanguage && vm.erpSections?.[vm.selectedLanguage])
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(vm.erpSections?.[vm.selectedLanguage]?.some((section) => section.name === entry.name)
                            ? `${_unref($t)("AiTexter.ERPSection")} ${entry.name}`
                            : vm.targetSelectionList.includes(entry.name)
                              ? _unref($t)(`AiTexter.${entry.name}`)
                              : entry.name), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      default: _withCtx(({ selectedItem, selectedText: text }) => [
                                        (selectedItem && vm.selectedLanguage && vm.erpSections?.[vm.selectedLanguage])
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(vm.erpSections?.[vm.selectedLanguage]?.some((section) => section.name === selectedItem.name)
                            ? `${_unref($t)("AiTexter.ERPSection")} ${selectedItem.name}`
                            : vm.targetSelectionList.includes(selectedItem.name)
                              ? _unref($t)(`AiTexter.${selectedItem.name}`)
                              : text), 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "items"])), [
                                      [_directive_tooltip, validationFeedbacks.value.name.type]
                                    ])
                                  ])
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("div", _hoisted_35, [
                                      _createElementVNode("span", _hoisted_36, _toDisplayString(_unref($t)("AiTexter.Field")), 1)
                                    ])
                                  ]),
                                  (vm.selectedTarget !== 'masterData' && vm.tableRows)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vm.tableRows, (row, index) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: `$tablerow-${index}`
                                          }, [
                                            ((isErpSectionItem(row) || isAttributeItem(row)) && row.name !== undefined && row.name !== null)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                  _createElementVNode("div", _hoisted_39, [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["ai-texter-table-row-data", { 'selected-row': vm.selectedAttributeToTarget == row }]),
                                                      onClick: ($event: any) => (setCurrentAttributePath(row))
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: "ai-texter-table-col ai-texter-target-table-col",
                                                        "data-cy": row.name
                                                      }, [
                                                        _withDirectives((_openBlock(), _createElementBlock("span", null, [
                                                          _createTextVNode(_toDisplayString(row.name), 1)
                                                        ])), [
                                                          [_directive_tooltip, row.name]
                                                        ])
                                                      ], 8, _hoisted_41)
                                                    ], 10, _hoisted_40)
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (vm.selectedTarget == 'masterData')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                        _createElementVNode("div", _hoisted_43, [
                                          _createElementVNode("div", _hoisted_44, [
                                            (vm.selectedLanguage && vm.masterData?.[vm.selectedLanguage])
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  "data-cy": "masterDataDescriptionTarget",
                                                  class: _normalizeClass(["ai-texter-table-row-data", {
                            'selected-row':
                              vm.selectedAttributeToTarget == vm.masterData?.[vm.selectedLanguage].description && vm.selectedMasterDataParameter !== 'name'
                          }]),
                                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (setCurrentMasterDataPath(vm.masterData?.[vm.selectedLanguage].description, 'description')))
                                                }, [
                                                  _createElementVNode("div", _hoisted_45, [
                                                    _createElementVNode("span", null, _toDisplayString(_unref($t)("AiTexter.Description")), 1)
                                                  ])
                                                ], 2))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_46, [
                                          _createElementVNode("div", _hoisted_47, [
                                            (vm.selectedLanguage && vm.masterData?.[vm.selectedLanguage])
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  class: _normalizeClass(["ai-texter-table-row-data", {
                            'selected-row':
                              vm.selectedAttributeToTarget == vm.masterData?.[vm.selectedLanguage].name && vm.selectedMasterDataParameter !== 'description'
                          }]),
                                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (setCurrentMasterDataPath(vm.masterData?.[vm.selectedLanguage].name, 'name')))
                                                }, [
                                                  _createElementVNode("div", _hoisted_48, [
                                                    _createElementVNode("span", null, _toDisplayString(_unref($t)("AiTexter.Name")), 1)
                                                  ])
                                                ], 2))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_b_col, { cols: "6" }, {
                            default: _withCtx(() => [
                              _createElementVNode("label", _hoisted_49, _toDisplayString(_unref($t)("AiTexter.CurrentValue")), 1),
                              _createVNode(_component_b_form_group, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_50, _toDisplayString(vm.currentValueOfItem), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (vm.selectedPage == 'generateAiText')
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("label", _hoisted_53, _toDisplayString(_unref($t)("AiTexter.Article")), 1),
                      (vm.selectedLanguage && vm.masterData?.[vm.selectedLanguage])
                        ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_54, [
                            _createTextVNode(_toDisplayString(vm.masterData?.[vm.selectedLanguage].name), 1)
                          ])), [
                            [_directive_tooltip, vm.masterData?.[vm.selectedLanguage].name]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("label", _hoisted_56, _toDisplayString(_unref($t)("AiTexter.Target")), 1),
                      _createElementVNode("span", _hoisted_57, _toDisplayString(targetSelectionList.includes(vm.selectedTextGeneratingTargetName)
                ? `${_unref($t)("AiTexter." + vm.selectedTextGeneratingTargetName)}`
                : vm.selectedTextGeneratingTargetName) + " / " + _toDisplayString(vm.selectedTextGeneratingTargetName === "masterData" && vm.selectedMasterDataParameter
                ? `${_unref($t)("AiTexter." + _unref(_).capitalize(vm.selectedMasterDataParameter))}`
                : !_unref(_).isString(vm.selectedAttributeToTarget)
                  ? vm.selectedAttributeToTarget?.name
                  : vm.selectedAttributeToTarget), 1)
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["drawer", { collapsed: !vm.isDrawerOpen, 'collapsed-area-left': !vm.isDrawerOpen, 'border-right': vm.isDrawerOpen }])
                      }, [
                        _createElementVNode("div", _hoisted_59, [
                          _createVNode(_component_b_form_group, { class: "current-value-box-form" }, {
                            label: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref($t)("AiTexter.CurrentValue")), 1)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_60, _toDisplayString(vm.currentValueOfItem), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", {
                          class: "drawer-collapse-button",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (vm.isDrawerOpen = !vm.isDrawerOpen))
                        }, [
                          _createElementVNode("span", _hoisted_61, [
                            (vm.isDrawerOpen)
                              ? (_openBlock(), _createBlock(Icon, {
                                  key: 0,
                                  icon: "ChevronLeft"
                                }))
                              : _createCommentVNode("", true),
                            _withDirectives(_createVNode(Icon, { icon: "ChevronRight" }, null, 512), [
                              [_vShow, !vm.isDrawerOpen]
                            ])
                          ]),
                          _withDirectives(_createElementVNode("span", { class: "drawer-collapse-button-text" }, _toDisplayString(_unref($t)("AiTexter.CurrentValue")), 513), [
                            [_vShow, !vm.isDrawerOpen]
                          ])
                        ])
                      ], 2),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("label", _hoisted_63, _toDisplayString(_unref($t)("AiTexter.GeneratedValue")), 1),
                        _withDirectives(_createVNode(HTMLEditor, {
                          modelValue: vm.editableText,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((vm.editableText) = $event)),
                          "data-cy": "ai-texter-tiny-mce"
                        }, null, 8, ["modelValue"]), [
                          [_vShow, !vm.isGenerating]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_64, [
                          _createVNode(Spinner, {
                            size: "48",
                            "data-cy": "spinner"
                          })
                        ], 512), [
                          [_vShow, vm.isGenerating]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data-cy", "title", "modelValue"]),
    _createVNode(warningModal, {
      id: "warning-modal",
      "show-modal": vm.showWarning,
      "onUpdate:showModal": _cache[13] || (_cache[13] = ($event: any) => ((vm.showWarning) = $event)),
      title: vm.apiErrorTitle,
      message: vm.apiErrorMessage
    }, null, 8, ["show-modal", "title", "message"]),
    _createVNode(NotificationModal, {
      "show-modal": vm.legalInformationModal,
      "onUpdate:showModal": _cache[14] || (_cache[14] = ($event: any) => ((vm.legalInformationModal) = $event)),
      onNotificationStatus: setNotificationStatus
    }, null, 8, ["show-modal"])
  ], 64))
}
}

})